import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {StateModule} from "./state.module";
import {Disclaimer} from "@flowpay/flow-ui";

@Injectable({providedIn: StateModule})
export class DisclaimerState {
  public disclaimer$: BehaviorSubject<Disclaimer | undefined> = new BehaviorSubject<Disclaimer | undefined>(undefined);
}
